import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const LabelSuffix = styled.span`
  font-size: 21px;
  line-height: 140%;
  color: ${({ theme }: { theme: Theme }) => theme.colors.input.labelSuffix};
  max-width: 50%;
  text-align: right;
`;
